import { useCallback } from 'react';
import { OperandType } from '../../../utils/apollo/graphqlSchema';
import { IPredicateFormFieldPath } from '../types';
import useFilterWidgetFormContext from './useFilterWidgetFormContext';
import { getPredicateFormFieldPath } from './formPath';

interface IResetPredicatesArgs {
  formPath: IPredicateFormFieldPath;
}

export const useResetPredicates = ({ formPath }: IResetPredicatesArgs) => {
  const { resetField } = useFilterWidgetFormContext();

  const fieldPath = getPredicateFormFieldPath(formPath);

  return useCallback(
    (selectedOperandType: OperandType) => {
      resetField(`${fieldPath}.matchCase`, { defaultValue: true });

      if (selectedOperandType === OperandType.Value) {
        resetField(`${fieldPath}.operand.operands`, { defaultValue: [] });
        resetField(`${fieldPath}.operand.fromOperand`, { defaultValue: null });
        resetField(`${fieldPath}.operand.toOperand`, { defaultValue: null });
      } else {
        resetField(`${fieldPath}.operand.field`, { defaultValue: null });
        resetField(`${fieldPath}.operand.fromField`, { defaultValue: null });
        resetField(`${fieldPath}.operand.toField`, { defaultValue: null });
      }
    },
    [fieldPath, resetField],
  );
};
